export enum LearningRequestSort {
  createdAt = "createdAt",
  updatedAt = "updatedAt",
  formedAt = "formedAt",
  number = "number"
}

export enum FileManagerSort {
  name = "name",
  modifiedAt = "modifiedAt",
  size = "size"
}

export enum ContractSort {
  createdAt = "createdAt",
  updatedAt = "updatedAt",
  formedAt = "formedAt",
  number = "number"
}

export enum ImportSort {
  startedAt = "startedAt",
  finishedAt = "finishedAt",
  createdAt = "createdAt",
  updatedAt = "updatedAt"
}

export enum RegistrationSort {
  startedAt = "startedAt",
  finishedAt = "finishedAt"
}

export enum StudentSort {
  name = "name",
  createdAt = "createdAt",
  updatedAt = "updatedAt"
}

export enum ContractorSort {
  updatedAt = "updatedAt"
}

export enum BillsSort {
  createdAt = "createdAt",
  updatedAt = "updatedAt",
  formedAt = "formedAt",
  number = "number"
}

export enum ActSort {
  createdAt = "createdAt",
  updatedAt = "updatedAt",
  formedAt = "formedAt",
  number = "number"
}

export enum TestsSort {
  id = "id",
  title = "title",
  createdAt = "createdAt",
  updatedAt = "updatedAt"
}

export enum RecordsSort {
  title = "title",
  createdAt = "createdAt",
  updatedAt = "updatedAt"
}

export enum LecturesSort {
  id = "id",
  title = "title",
  createdAt = "createdAt",
  updatedAt = "updatedAt"
}

export enum OrderSort {
  ASC = "ASC",
  DESC = "DESC"
}

export enum AgentPaymentSort {
  paymentAt = "paymentAt"
}

export class SortFields<S> {
  protected sortField: S;
  protected orderField: OrderSort;
  protected isChangedOrder: boolean = false; //variable for change order
  protected iconDown = "fas fa-long-arrow-alt-down";
  protected iconUp = "fas fa-long-arrow-alt-up";

  constructor(sort: S, order: OrderSort = OrderSort.DESC) {
    this.sortField = sort;
    this.orderField = order;
  }

  public changeSort(sortField: S) {
    if (this.sort === sortField) {
      this.isChangedOrder = !this.isChangedOrder;
      this.order = this.isChangedOrder ? OrderSort.ASC : OrderSort.DESC;
    } else {
      this.isChangedOrder = false;
      this.order = this.isChangedOrder ? OrderSort.ASC : OrderSort.DESC;
      this.sort = sortField;
    }
  }

  getIcon(sort: S) {
    let status;
    if (sort === this.sort) {
      status = this.isChangedOrder ? this.iconUp : this.iconDown;
    }
    return status;
  }

  get sort(): S {
    return this.sortField;
  }

  set sort(sort: S) {
    this.sortField = sort;
  }

  get order(): OrderSort {
    return this.orderField;
  }

  set order(order: OrderSort) {
    this.orderField = order;
  }
}
